import React, { useEffect, useState } from 'react';
import { Eye, EyeOff, Facebook, Linkedin, Twitter } from 'react-feather';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { Btn, H4, P, H6, Image } from '../../../AbstractElements';
import { Link, useNavigate } from 'react-router-dom';
import logoWhite from '../../../assets/images/logo/fitFind2.png';
import logoDark from '../../../assets/images/logo/logo_dark.png';
import { createMerchant } from '../../../api-handle/authApi';
import { setSession } from '../../../api-handle/authService';
import FitfindLogo from "../../../../src/assets/images/fitfind-logo.png"

const RegisterForm = ({ logoClassMain }) => {
  const [togglePassword, setTogglePassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("")
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    phone: '',
  });


  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
    setErrors({ ...errors, [name]: '' });
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    const validationErrors = validate();
    setErrors((prevErrors) => ({ ...prevErrors, [name]: validationErrors[name] }));
  };

  const validate = () => {
    let newErrors = {};
    if (!formData.name) newErrors.name = 'Name is required';
    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)) {
      newErrors.email = 'Invalid email address';
    }
    if (!formData.password) newErrors.password = 'Password is required';
    if (!formData.agree) newErrors.agree = 'You must agree to the Privacy Policy';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    { errorMessage && setErrorMessage("") }
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      console.warn('Form validation failed:', validationErrors);
      return;
    }

    try {
      //'Submitting form data:', formData);
      const response = await createMerchant(formData);

      if (response?.token) {
        setSession(response.token, response.refreshToken);
        localStorage.setItem('login', JSON.stringify(true));
        localStorage.setItem("isFirstTime", true)
        navigate('/merchant/details');
      } else {
        console.error('Registration failed: No token received.');
      }
    } catch (error) {
      if (!error?.isSuccess) {
        //"Response : ", error.message)
        setErrorMessage(error?.message)
        return;
      }
      console.error('Error during registration:', error);
    }
  };

  return (
    <div className='login-card'>
      <div>
        <div>
          <Link className={`logo ${logoClassMain || ''}`} to={process.env.PUBLIC_URL}>
            <Image attrImage={{ className: 'img-fluid for-light', src: logoWhite, alt: 'login page', style: { height: "100px" } }} />
          </Link>
        </div>
        <div className='login-main'>
          <Form className='theme-form login-form' onSubmit={handleSubmit}>
            <H4>Create your account</H4>
            <P>Enter your personal details to create an account</P>
            {errorMessage && <p className='' style={{ color: "#ff0000ad" }}>{errorMessage}</p>}

            <FormGroup>
              <Label className='col-form-label'>Your Name</Label>
              <Input
                className='form-control'
                type='text'
                name='name'
                value={formData.name}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder='Full Name'
              />
              {errors.name && <p className='' style={{ color: "#ff0000ad" }}>{errors.name}</p>}
            </FormGroup>
            <FormGroup>
              <Label className='col-form-label'>Email Address</Label>
              <Input
                className='form-control'
                type='email'
                name='email'
                value={formData.email}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder='example@gmail.com'
              />
              {errors.email && <p className='' style={{ color: "#ff0000ad" }}>{errors.email}</p>}
            </FormGroup>
            <FormGroup>
              <Label className='col-form-label'>Phone (Optional)</Label>
              <Input
                className='form-control'
                type='tel'
                name='phone'
                value={formData.phone}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only digits and limit to 16 digits
                  if (/^\d{0,16}$/.test(value)) {
                    handleChange(e);
                  }
                }}
                placeholder='Phone Number'
                pattern="[0-9]{0,16}"
                maxLength="16"
                onInvalid={(e) => e.target.setCustomValidity('Please enter a valid phone number (digits only, up to 16 digits)')}
                onInput={(e) => e.target.setCustomValidity('')}
              />
            </FormGroup>
            <FormGroup className='position-relative'>
              <Label className='col-form-label'>Password</Label>
              <div className='position-relative'>
                <Input
                  className='form-control'
                  type={togglePassword ? 'text' : 'password'}
                  name='password'
                  value={formData.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder='*********'
                />
                <div className='show-hide' style={{ cursor: "pointer" }} onClick={() => setTogglePassword(!togglePassword)}>
                  {togglePassword ? <Eye color='#33bdbf' size={16} /> : <EyeOff color='#33bdbf' size={16} />}
                </div>
              </div>
              {errors.password && <p className='' style={{ color: "#ff0000ad" }}>{errors.password}</p>}
            </FormGroup>
            <FormGroup>
              <div className='checkbox'>
                <Input id='checkbox1' type='checkbox' name='agree' checked={formData.agree} onChange={handleChange} />
                <Label className='text-muted' for='checkbox1'>
                  Agree with <span>Privacy Policy</span>
                </Label>
              </div>
              {errors.agree && <p className='' style={{ color: "#ff0000ad" }}>{errors.agree}</p>}
            </FormGroup>
            <FormGroup>
              <Btn attrBtn={{ className: 'd-block w-100', color: 'primary', type: 'submit' }}>Create Account</Btn>
            </FormGroup>
            <P className='mb-0 text-start'>
              Already have an account?
              <Link className='ms-2' to={`${process.env.PUBLIC_URL}/login`}>Sign in</Link>
            </P>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default RegisterForm;
